import * as React from 'react';
import styled from 'styled-components';

const StyledPostIconsWrapper = styled.div<{ $padding: React.CSSProperties['padding']; $gap?: number }>`
    display: flex;

    align-items: center;

    justify-content: center;

    padding: ${props => props.$padding};

    color: rgba(0, 0, 0, 0.54);

    ${props => props.$gap && `gap: ${props.theme.spacing(props.$gap)}px`};
`;

interface ReportPostIconsProps {
    children?: React.ReactNode;
    iconGap?: number;
    padding?: React.CSSProperties['padding'];
}

export const ReportPostIcons: React.FC<ReportPostIconsProps> = ({ iconGap = 2, padding = '5px', ...props }) => (
    <StyledPostIconsWrapper $gap={iconGap} $padding={padding} {...props} />
);
ReportPostIcons.displayName = 'ReportPostIcons';
